import { render, staticRenderFns } from "./UpdateTimeUnidad.vue?vue&type=template&id=2ebab464"
import script from "./UpdateTimeUnidad.vue?vue&type=script&lang=js"
export * from "./UpdateTimeUnidad.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports